import { CaseReducer, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { QueryParams } from 'renderer/shared/schemas/common.schemas';

export type TransactionQueryParams = QueryParams & {
  startDate?: string;
  endDate?: string;
};

type TransactionsState = TransactionQueryParams;

const initialState: TransactionsState = {
  page: 1,
  limit: 10,
  sortBy: 'createdAt',
  sortOrder: 'desc',
  search: '',
  startDate: undefined,
  endDate: undefined,
};

const resetReducer: CaseReducer<TransactionsState> = () => {
  return initialState;
};

export const transactionSlice = createSlice({
  name: 'transaction',
  initialState: initialState as TransactionsState,
  reducers: {
    resetTransactionsTable: resetReducer,
    setTransactionQuery: (
      state,
      { payload }: PayloadAction<TransactionQueryParams>,
    ) => {
      return payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { resetTransactionsTable, setTransactionQuery } =
  transactionSlice.actions;

export default transactionSlice.reducer;
